import React from "react";
import { useNavigate } from "react-router-dom";
import { Dropdown, Tooltip } from "antd";
import { EllipsisOutlined } from "@ant-design/icons";
import { exhibitionUseMutation } from "../hooks";
import ExhibitionConst from "../exhibition-const";
import { EntityRemoveButton, Localize } from "components/service";
import { localizeByKey } from "components/service/localize";
import type { TExhibitionType } from "components/exhibition/helpers/exhibition-types-helper";
import type { TOrganizer } from "components/organizer/helpers/organizer-types-helper";
import Icons from "components/icons";
import { usePermissionByObject, useModelFormValidation } from "components/permissions";
import Exhibitions from "components/exhibition";


interface IExhibitionActionFieldProps
{
  exhibition: TExhibitionType | undefined;
  organizer: TOrganizer | undefined;
}


const ExhibitionActionField: React.FC<IExhibitionActionFieldProps> = ({ exhibition, organizer }) =>
{

  const navigate = useNavigate();

  const { _setMutationExhibitionDelete, loadingMutationExhibitionDelete } =
    exhibitionUseMutation.delete(exhibition?.id, organizer);

  const { hasPermission: hasUpdatePermission } = usePermissionByObject(Exhibitions.Const.permissions.UPDATE);
  const { hasPermission: hasDeletePermission } = usePermissionByObject(Exhibitions.Const.permissions.DELETE);
  const { validateDeletePermission } = useModelFormValidation(Exhibitions.Const);

  const items = [
    {
      label: (
        <Tooltip title={!hasUpdatePermission ? localizeByKey('PERMISSION.Error_AccessDenied') : ''}>
          <span style={{ display: "flex", alignItems: "center", width: 100 }}>
            <Icons.Edit /> <Localize>MENUS_DROP.Label_Edit</Localize>
          </span>
        </Tooltip>
      ),
      key: "1",
      disabled: !hasUpdatePermission,
      onClick: () => {
        if (!hasUpdatePermission) return;
        navigate(`${ExhibitionConst.basePath}/${exhibition?.id}`);
      },
    },
    {
      key: "2",
      label: (
        <Tooltip title={!hasDeletePermission ? localizeByKey('PERMISSION.Error_AccessDenied') : ''}>
          <EntityRemoveButton
            modalButton={
              <span style={{ display: "flex", alignItems: "center", width: 100 }}>
                <Icons.Delete /> <Localize>MENUS_DROP.Label_Delete</Localize>
              </span>
            }
            nameEntity={
              localizeByKey("ENTITY.Modal_Title_ExhibitionType")
            }
            dataNameEntity={exhibition?.title}
            loading={loadingMutationExhibitionDelete}
            deleteMutation={(options) => {
              if (!validateDeletePermission()) {
                return Promise.reject(new Error('Access denied'));
              }
              return _setMutationExhibitionDelete(options);
            }}
            variables={{
              id: exhibition?.id,
            }}
          />
        </Tooltip>
      ),
      disabled: !hasDeletePermission,
    },
  ];

  return (
    <Dropdown
      // trigger={['click']}
      placement="bottomRight"
      menu={{ items }}
      overlayClassName="drop-more-menu"
      arrow
    >
      <EllipsisOutlined className="btn-more" />
    </Dropdown>
  );
};

export default ExhibitionActionField;
